import React from 'react';
import PropTypes from 'prop-types';
import { AlertCircle, Check, X } from 'tabler-icons-react';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppStack from '../../common/AppStack';
import { getTeamLaunchStatus } from '../../../helpers/teamGeneration';
import AppText from '../../common/AppText';
import PaginationList from '../../common/PaginationList';
import AppFlexbox from '../../common/AppFlexbox';
import AppCard from '../../common/AppCard';

const TeamSyncStatusModal = ({ isOpen, onClose, regTeam }) => {
  const teamStatus = regTeam ? getTeamLaunchStatus(regTeam) : null;

  return (
    <ResponsiveModal
      centered
      formSectionProps={{
        onCancel: onClose,
        isSubmitHidden: true,
        onSubmit: () => {}
      }}
      isNewModalStyle
      onClose={onClose}
      opened={isOpen && !!teamStatus}
      title="Team sync status"
    >
      {regTeam?.team && teamStatus && (
        <AppStack style={{ gap: 16 }}>
          {teamStatus.isDeleted && (
            <AppCard radius={8} shadow="xs" style={{ padding: 0 }} withBorder>
              <AppFlexbox
                style={{
                  padding: 8,
                  gap: 8,
                  backgroundColor: '#c40000',
                  color: '#fff',
                  alignItems: 'center'
                }}
              >
                <AppStack>
                  <AlertCircle size={18} />
                </AppStack>
                <AppText style={{ fontSize: 14 }}>Website team deleted</AppText>
              </AppFlexbox>
              <AppStack style={{ padding: 8 }}>
                <AppText style={{ fontSize: 14 }}>
                  Please rebase the connection or reimport the team to sync
                  players.
                </AppText>
              </AppStack>
            </AppCard>
          )}

          <AppStack style={{ gap: 5 }}>
            <AppText style={{ fontSize: 16, fontWeight: 500 }}>
              Registration team
            </AppText>

            <PaginationList
              emptyMessage="No players found in this team"
              items={
                teamStatus.players?.map((p) => {
                  const isSynced =
                    p.websitePlayer &&
                    p.websitePlayer.isActive === p.regPlayer.active;

                  return (
                    <AppFlexbox
                      key={p.regPlayer.pkRegAssociationDivisionTeamPerson}
                      style={{
                        gap: 5,
                        padding: 8,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        overflow: 'hidden'
                      }}
                    >
                      <AppFlexbox
                        style={{
                          gap: 5,
                          alignItems: 'center',
                          overflow: 'hidden'
                        }}
                      >
                        <AppStack style={{ gap: 0 }}>
                          <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                            {p.regPlayer.regPerson.firstName}{' '}
                            {p.regPlayer.regPerson.lastName}
                          </AppText>
                          <AppText style={{ fontSize: 14, color: '#666' }}>
                            Status:{' '}
                            <span
                              style={{color: p.regPlayer.active ? 'green' : '#C40000'}}
                            >
                              {p.regPlayer.active ? 'Active' : 'Inactive'}
                            </span>
                          </AppText>
                        </AppStack>
                      </AppFlexbox>

                      <AppStack
                        style={{
                          gap: 0,
                          alignItems: 'flex-end'
                        }}
                      >
                        {isSynced ? (
                          <Check color="green" />
                        ) : (
                          <>
                            <X color="#C40000" />
                            <AppText style={{ fontSize: 14, color: '#666' }}>
                              {!p.websitePlayer
                                ? 'Player not on website team'
                                : `Player is ${
                                    p.websitePlayer.isActive
                                      ? 'active'
                                      : 'inactive'
                                  } on website team`}
                            </AppText>
                          </>
                        )}
                      </AppStack>
                    </AppFlexbox>
                  );
                }) || []
              }
            />
          </AppStack>

          {teamStatus.externalWebsitePlayers &&
            teamStatus.externalWebsitePlayers.length > 0 && (
              <AppStack style={{ gap: 5 }}>
                <AppStack style={{ gap: 0 }}>
                  <AppText style={{ fontSize: 16, fontWeight: 500 }}>
                    External players
                  </AppText>
                  <AppText style={{ fontSize: 14, color: '#666' }}>
                    These are active players on the website team that do not
                    exist in the registration team.
                  </AppText>
                </AppStack>

                <PaginationList
                  emptyMessage="No external players found"
                  items={teamStatus.externalWebsitePlayers.map((p) => (
                    <AppFlexbox
                      key={p.pkUser}
                      style={{
                        gap: 5,
                        padding: 8,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        overflow: 'hidden'
                      }}
                    >
                      <AppFlexbox
                        style={{
                          gap: 5,
                          alignItems: 'center',
                          overflow: 'hidden'
                        }}
                      >
                        <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                          {p.name}
                        </AppText>
                      </AppFlexbox>
                    </AppFlexbox>
                  ))}
                />
              </AppStack>
            )}
        </AppStack>
      )}
    </ResponsiveModal>
  );
};

TeamSyncStatusModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  regTeam: PropTypes.object
};

export default TeamSyncStatusModal;
